export default __webpack_public_path__ + "static/media/thermalmodel-logo.00e2dcb9.png";